import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { IUser } from '@entities/user/IUser';

export interface IUserState {
  user: IUser | null;
  isLoggedIn: boolean;
  lastUploadedReportAt: string | null;
  permissions: string[];
}

const initialState: IUserState = {
  user: null,
  isLoggedIn: false,
  lastUploadedReportAt: null,
  permissions: [],
};

export const userSlice = createSlice({
  initialState,
  name: 'userSlice',
  reducers: {
    logout: () => {
      localStorage.clear();

      return initialState;
    },
    setUser: (state: any, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    setLastUploadedReportAt: (state: any, action: PayloadAction<string>) => {
      state.lastUploadedReportAt = action.payload;
    },
    setPermissions: (state: any, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },
  },
});

export default userSlice.reducer;

export const selectCurrentUser = (state: RootState) => state.me;
export const selectLastUploadedReportAt = (state: RootState) => state.me.lastUploadedReportAt;
export const selectPermissions = (state: RootState) => state.me.permissions;
export const selectIsManager = (state: RootState) => state.me.user?.is_sales_team === true;

export const { logout, setUser, setLastUploadedReportAt, setPermissions } = userSlice.actions;
